// extracted by mini-css-extract-plugin
export default {"container":"UserProfileButtonSkeleton_container__xvxO0","title":"UserProfileButtonSkeleton_title__ThKJu"};